import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'material-ui/Button';
import CardActions from 'material-ui/Card/CardActions';
import { CircularProgress } from 'material-ui/Progress';
import KPIBar from '../../../view/analytics/KPIBar';
import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import * as AppState from '../../../state/reducer/app/appState';
import * as DateUtils from '../../../lib/dateUtils';

const PAGE_KEY = 'marketplace-trials';
const TRIALS_PATH = `/analytics/${PAGE_KEY}`;

export default function TrialKPICard(props) {
    const dispatch = useDispatch();
    const [month, setMonth] = useState();
    const [didLoadCurrentMonth, setDidLoadCurrentMonth] = useState(false);
    const loggedInUser = useSelector(state => state.app.loggedInUser);
    const headCoach = useSelector(state => state.app.headCoach);
    const analyticsLoading = useSelector(state => {
        if (state.app.analyticsLoading === undefined) {
            return false;
        }
        return state.app.analyticsLoading;
    });
    const loadAnalytics = useCallback(
        () => {
            let startDate = moment().startOf('month');
            let endDate = startDate.clone().endOf('month');
            endDate = moment(endDate, DateUtils.CALENDAR_FORMAT);
            setMonth(startDate.format('MMMM'));
            let dataParams = {
                date_start: moment(startDate).format(DateUtils.CALENDAR_FORMAT),
                date_end: moment(endDate).format(DateUtils.CALENDAR_FORMAT)
            };
            dispatch(initializeAnalytics(PAGE_KEY, dataParams));
            setDidLoadCurrentMonth(true);
        },
        [dispatch]
    );
    useEffect(
        () => {
            if (!didLoadCurrentMonth && !analyticsLoading) {
                AppState.setAnalyticsLoading();
                loadAnalytics();
            }
        },
        [didLoadCurrentMonth, loadAnalytics, analyticsLoading]
    );
    if (loggedInUser.mpEnabled && headCoach) {
        return (
            <div className="trial-kpis">
                <h2>{month} Marketplace Trials</h2>
                {didLoadCurrentMonth && !analyticsLoading ? (
                    <KPIBar />
                ) : (
                    <div className="load-progress">
                        <CircularProgress />
                    </div>
                )}
                <CardActions className="card-actions">
                    <Button className="button">
                        <a href={TRIALS_PATH}>View Analytics</a>
                    </Button>
                </CardActions>
            </div>
        );
    }
    return '';
}



// WEBPACK FOOTER //
// ./src/v5/home/components/TrialKPICard.jsx